export function returnChecked(option: any, list: string[]): boolean {
    return list.includes(option.value);
}